import { CommonModule } from '@angular/common';
import { DatiqIconsModule } from '@dat/datiq-components-pkg/icons';
import { DatiqModalBgComponent } from './components/datiq-modal-bg/datiq-modal-bg.component';
import { DatiqModalComponent } from './components/datiq-modal/datiq-modal.component';
import { DatiqModalFullScreenComponent } from './components/datiq-modal-full-screen/datiq-modal-full-screen.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        DatiqModalComponent,
        DatiqModalBgComponent,
        DatiqModalFullScreenComponent,
    ],
    imports: [CommonModule, MatButtonModule, DatiqIconsModule, MatIconModule],
    exports: [DatiqModalComponent, DatiqModalFullScreenComponent],
})
export class DatiqModalModule {}
